import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PageBodyContainer = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    min-height: 100vh;
`;